import React from 'react'
import 'normalize.css/normalize.css'
import '../../styles/sass/main.scss'

import Header from './layout/header.component'
import Account from './account/account.component'
import Footer from '../layout/footer.component'
import SideNavigation from './layout/sideNavigation.component'

import Login from './account/login.component'
import Register from '../../containers/employer/register.container'
import Callback from '../../containers/employer/callback.container'
import CompanyProfile from '../../containers/employer/companyProfile/companyProfile.container'
import LightEntrepreneurs from '../../containers/employer/lightEntrepreneurs/lightEntrepreneurs.container'
import Assignments from '../../containers/employer/assignments/assignments.container'
import Applications from '../../containers/employer/applications/applications.container'
import Workshifts from '../../containers/employer/workshifts/workshifts.container'
import Contract from '../../containers/employer/contract/contract.container'
import Welcome from './account/welcome.component'
import { Route, Switch } from 'react-router-dom'
import { PrivateRoute } from '../../routes'

/**
 * The main component for handling user authentication requests.
 *
 * @author Pragya Gupta
 */

const Main = ({ user, navItems, path, handleManualLogout, lang }) => {
  const renderSideNavigation = user
  const isDesktop = window.innerWidth >= 768

  return (
    <div>
      <Header
        user={user}
        navItems={navItems}
        handleManualLogout={handleManualLogout}
      />
      <div
        style={
          renderSideNavigation && isDesktop
            ? {
                display: 'grid',
                gridTemplateColumns:
                  'var(--sidebar-width) calc(100% - var(--sidebar-width))'
              }
            : {}
        }
      >
        {renderSideNavigation && (
          <SideNavigation user={user} navItems={navItems} />
        )}
        <Switch>
          <Route path="/dashboard/employerLogin">
            <Login />
          </Route>
          <Route path="/dashboard/employerRegister">
            <Register />
          </Route>
          <Route path="/kiitos-rekisteroitymisesta">
            <Welcome />
          </Route>
          <Route path="/dashboard/callback_employer">
            <Callback />
          </Route>
          <PrivateRoute exact path="/dashboard/lightEntrepreneurs">
            <LightEntrepreneurs />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/assignments">
            <Assignments />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/applications">
            <Applications />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/workshifts">
            <Workshifts />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/companyProfile">
            <CompanyProfile />
          </PrivateRoute>
          <PrivateRoute path="/dashboard/contract">
            <Contract />
          </PrivateRoute>
        </Switch>
      </div>
      {!user &&
        path !== '/dashboard/employerRegister' &&
        path !== '/dashboard/employerLogin' && <Account />}
      <Footer lang={lang} />
    </div>
  )
}

export default Main
